<template>
  <div>
    <AtomLoadingSecondary/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapActivation',

  created () {
    this.$router.push(`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.activation.subject')}/${this.$t('mEditionMenu.map.activation.children.days.subedition')}`)
  }
}
</script>
